import { OrderedListDragDropData } from './../../../models/ordered-list-drag-drop-data';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ra-ordered-list-drag-drop-popup',
  templateUrl: './ordered-list-drag-drop-popup.component.html',
  styleUrls: ['./ordered-list-drag-drop-popup.component.scss'],
  standalone: false,
})
export class OrderedListDragDropPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<OrderedListDragDropPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OrderedListDragDropData,
  ) {}

  onCancel() {
    this.dialogRef.close(false);
  }

  onOrderChanged(list: any[]) {
    this.data?.orderChanged?.(list);
  }

  onOk() {
    this.dialogRef.close(true);
  }
}
